import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-32 text-center">
      <h1 className="text-4xl font-semibold tracking-tight">404</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        That page does not exist. The run you are looking for may have been
        removed or never existed.
      </p>
      <Button asChild>
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  );
}
